import { combineReducers } from "@reduxjs/toolkit";
import commentsSlice from "./commentsSlice";

export default combineReducers({
  comments: commentsSlice,
});
